export const getCurrentLanguage = (): string => {
  return window.currentLanguage;
};
